module.exports = __webpack_public_path__ + "e2ddd7d6ac99fcbb3b5613daf028bd44.svg";